import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GetSingleWithdrawalsRequest } from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

const SingleWithdrawRequest = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const state = location.state || {};
  const [data, setData] = useState();
  const [previewImage, setPreviewImage] = useState(null);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const fetchData = async () => {
    const resp = await GetSingleWithdrawalsRequest(id, state);
    if (resp.status === 200) {
      setData(resp?.data?.data);
    }
  };

  const fields = data?.user_payment_method?.fields;

  useEffect(() => {
    if (state !== "waiting") {
      fetchData();
    }
  }, [state]);

  return (
    <>
      <Box sx={{ width: "80%", margin: "20px auto" }}>
        <Box
          sx={{
            display: "flex",
            gap: "40%",
            alignItems: "center",
            position: "fixed",
            top: 5,
          }}
        >
          <ArrowBackIcon onClick={() => navigate(-1)} />
        </Box>
        {state === "waiting" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <Typography>No Data</Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ textAlign: "center", mt: 3 }}>
              <Typography variant="h4">{data?.amount}</Typography>
            </Box>
            <Box sx={{ textAlign: "end" }}>
              {state === "paid" || state === "done" || state === "paying" ? (
                <Typography variant="caption" color="#858383ff">
                  Submitted At:{" "}
                  {moment(data?.submitAt).format("YYYY-MM-DD hh:mm A")}
                </Typography>
              ) : state === "report" || state === "decline" ? (
                <Typography variant="caption" color="#858383ff">
                  Reported At:{" "}
                  {moment(data?.created).format("YYYY-MM-DD hh:mm A")}
                </Typography>
              ) : (
                <Typography variant="caption" color="#858383ff">
                  Created At:{" "}
                  {moment(data?.created).format("YYYY-MM-DD hh:mm A")}
                </Typography>
              )}
            </Box>
            {/* Amount Details */}
            <Box
              sx={{
                border: "1px solid grey",
                borderRadius: "13px",
                p: 2,
                mt: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              <Typography fontWeight={600} mb={0.5}>
                Amount Details:
              </Typography>
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Typography mb={0.5}>Order Id:</Typography>
                <Typography>
                  {/* <img src={rcoin} style={{ height: "15px", width: "15px" }} />{" "} */}
                  {data?.orderId}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Typography mb={0.5}>Deduction Amount:</Typography>
                <Typography>
                  {/* <img src={rcoin} style={{ height: "15px", width: "15px" }} />{" "} */}
                  {data?.deductedTax}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Typography>Payment Amount</Typography>
                <Typography>
                  {data?.amount} ={" "}
                  {/* <img src={rcoin} style={{ height: "15px", width: "15px" }} />{" "} */}
                  {data?.rcoin}
                </Typography>
              </Box>
            </Box>
            {/* Payment Method */}
            <Box
              sx={{
                border: "1px solid grey",
                borderRadius: "13px",
                p: 2,
                mt: 2,
              }}
            >
              <Typography fontWeight={600} mb={0.5}>
                Payment Method:
              </Typography>
              <Typography>
                {data?.user_payment_method?.paymentMethod?.name}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Typography fontWeight={600} mb={0.5}>
                Wallet Address:
              </Typography>
              <Box>
                {data?.user_payment_method?.paymentMethod?.type == "bank" ? (
                  <>
                    {fields && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography>Bank Name:</Typography>
                          <Typography variant="body2">
                            {fields.bankName}
                          </Typography>
                          <IconButton
                            onClick={() => copyToClipboard(fields.bankName)}
                          >
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography>Account Holder:</Typography>
                          <Typography variant="body2">
                            {fields.holderName}
                          </Typography>
                          <IconButton
                            onClick={() => copyToClipboard(fields.holderName)}
                          >
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography>Bank Account:</Typography>
                          <Typography variant="body2">
                            {fields.bankAccount}
                          </Typography>
                          <IconButton
                            onClick={() => copyToClipboard(fields.bankAccount)}
                          >
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography>IBAN Number:</Typography>
                          <Typography variant="body2">
                            {fields.ibanNumber}
                          </Typography>
                          <IconButton
                            onClick={() => copyToClipboard(fields.ibanNumber)}
                          >
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </>
                    )}
                  </>
                ) : data?.user_payment_method?.paymentMethod?.type == "epay" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Typography>Account:</Typography>
                      <Typography variant="body2">{fields.account}</Typography>
                      <IconButton
                        onClick={() => copyToClipboard(fields.account)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </>
                ) : data?.user_payment_method?.paymentMethod?.type == "usdt" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Typography>Wallet Address:</Typography>
                      <Typography variant="body2">
                        {fields.walletAddress}
                      </Typography>
                      <IconButton
                        onClick={() => copyToClipboard(fields.walletAddress)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </>
                ) : data?.user_payment_method?.paymentMethod?.type ==
                  "binance" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Typography>Wallet Address:</Typography>
                      <Typography variant="body2">
                        {fields.walletAddress}
                      </Typography>
                      <IconButton
                        onClick={() => copyToClipboard(fields.walletAddress)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </>
                ) : data?.user_payment_method?.paymentMethod?.type ==
                  "jazzcash" ? (
                  <>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Typography>Holder Name:</Typography>
                        <Typography variant="body2">
                          {fields.holderName}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Typography>Account Number:</Typography>
                        <Typography variant="body2">
                          {fields.jazzCashNumber || fields.accountNumber}
                        </Typography>
                        <IconButton
                          onClick={() =>
                            copyToClipboard(
                              fields.jazzCashNumber || fields.accountNumber
                            )
                          }
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </>
                ) : data?.user_payment_method?.paymentMethod?.type ==
                  "easypaisa" ? (
                  <>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Typography>Holder Name:</Typography>
                        <Typography variant="body2">
                          {fields.holderName}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Typography>Account Number:</Typography>
                        <Typography variant="body2">
                          {fields.easypaisaNumber || fields.accountNumber}
                        </Typography>
                        <IconButton
                          onClick={() =>
                            copyToClipboard(
                              fields.easypaisaNumber || fields.accountNumber
                            )
                          }
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </>
                ) : (
                  <>
                    <Typography>No Payment Details Mention</Typography>
                  </>
                )}
              </Box>
            </Box>
            {/* User Details */}
            <Box
              sx={{
                border: "1px solid grey",
                borderRadius: "13px",
                p: 2,
                mt: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              <Typography fontWeight={600} mb={0.5}>
                User Details:
              </Typography>
              <Box>
                <Avatar src={fileUrl + data?.user?.picture} />
                <Typography>{data?.user?.code} </Typography>
                <Typography>{data?.user?.name}</Typography>
                <Typography> {data?.user?.user_name}</Typography>
              </Box>
            </Box>
            {/* Merchant Details */}
            <Box
              sx={{
                border: "1px solid grey",
                borderRadius: "13px",
                p: 2,
                mt: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              <Typography fontWeight={600} mb={0.5}>
                Merchant Details:
              </Typography>
              <Box>
                <Avatar src={fileUrl + data?.merchant?.picture} />
                <Typography>{data?.merchant?.code} </Typography>
                <Typography>{data?.merchant?.name}</Typography>
                <Typography> {data?.merchant?.user_name}</Typography>
              </Box>
            </Box>
            {(state === "decline" || state === "report") && (
              <Box
                sx={{
                  border: "1px solid grey",
                  borderRadius: "13px",
                  p: 2,
                  mt: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                }}
              >
                <Typography fontWeight={600} mb={0.5}>
                  Reason:
                </Typography>
                <Box>
                  <Typography>{data?.description} </Typography>
                </Box>
              </Box>
            )}
            {/* Proof Show */}
            {state == "paid" && (
              <>
                <Box sx={{ mt: 2 }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Proof Images
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid grey",
                      padding: "10px",
                      borderRadius: "13px",
                    }}
                  >
                    {Array.isArray(data?.picture)
                      ? data.picture.map((imgPath, index) => (
                          <img
                            key={index}
                            src={fileUrl + imgPath}
                            alt={data?.user?.name}
                            style={{
                              height: "20vh",
                              width: "20vw",
                              objectFit: "contain",
                              marginRight: "0px",
                              borderRadius: "10%",
                            }}
                            onClick={() =>
                              setPreviewImage(
                                imgPath?.startsWith("/")
                                  ? fileUrl + imgPath
                                  : fileUrl + "/" + imgPath
                              )
                            }
                          />
                        ))
                      : JSON.parse(data?.picture || "[]").map(
                          (imgPath, index) => (
                            <img
                              key={index}
                              src={
                                imgPath?.startsWith("/")
                                  ? fileUrl + imgPath
                                  : fileUrl + "/" + imgPath
                              }
                              alt={data?.user?.name}
                              style={{
                                height: "20vh",
                                width: "20vw",
                                objectFit: "contain",
                                borderRadius: "10%",
                              }}
                              onClick={() =>
                                setPreviewImage(
                                  imgPath?.startsWith("/")
                                    ? fileUrl + imgPath
                                    : fileUrl + "/" + imgPath
                                )
                              }
                            />
                          )
                        )}
                  </Box>
                </Box>
              </>
            )}
          </>
        )}

        {/* ✅ Modal for Image Preview */}
        <Modal
          open={Boolean(previewImage)}
          onClose={() => setPreviewImage(null)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative", // to position the close button inside
              bgcolor: "white",
              borderRadius: "10px",
              p: 2,
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <IconButton
              onClick={() => setPreviewImage(null)}
              sx={{
                position: "relative",
                top: -10,
                right: 0,
                color: "#333",
                backgroundColor: "#f1f1f1",
                ":hover": {
                  backgroundColor: "#ddd",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* ✅ Preview Image */}
            <img
              src={previewImage}
              alt="Preview"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default SingleWithdrawRequest;
